<template>
  <div>
    <container>
      <div class="logo"><sprite name="logoBlasts" width="300"></sprite></div>
      <div role="alert">
        <h1>You have been logged off.</h1>
        <p>
          <a href="" @click="close()">Please close this window or tab</a>
        </p>
      </div>
    </container>
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  name: 'Logout',
  routeConfig: {
    name: "logout", path: "/logout",
    meta: { public: true }
  },
  metaInfo: {
    title: "Logout"
  },
  data() {
    return {
      showSignInLink: this.$classicParams.env == 'dev'
    };
  },
  created() {
    const isMimic = _.get(this.$session, 'session.isMimic')
    this.$session.destroy()
    this.$classicParams.$destroy()
    if (isMimic) {
      this.close()
    }
  },
  methods: {
    close() {
      window.close()
    }
  }
};
</script>

<style lang="scss" scoped>

  @import "~globals";

  h1 {
    @include font-size(xlarge, $headline: true); text-align:center;
  }

  p {
    text-align: center;
  }

  a {
    color:$color-primary; text-decoration:none;
  }

  .logo {
    display:block; margin:4rem 0; text-align:center;
  }

  nav {
    display:flex; margin-top: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/routes/logout/index.vue